import React, { useContext } from "react";
import { MixtureListProgressStyled } from "./MixtureListProgressStyled";
import { useSelector } from "react-redux";
import { getDataFromMixture } from "../../Mixture/selectors";
import { MixtureChooseEnum } from "../../../entities/Mixture";
import { getMixtureLineProgressColor } from "../../../utils/getMixtureLineProgressColor";
import { TranslationContextInterface } from "../../../entities/Language";
import { TranslationContext } from "../../../context/TranslationContext";
import { getValueForKey } from "../../../context/translationsUtils";

const MixtureListProgress: React.FC = () => {
  const { mixtureOption, totalPercentage } = useSelector(getDataFromMixture);
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);

  if (
    mixtureOption === MixtureChooseEnum.PARTS ||
    mixtureOption === MixtureChooseEnum.GRAMS
  ) {
    return null;
  }

  return (
    <>
      <MixtureListProgressStyled>
        <div
          className={`mixture-progress__current ${getMixtureLineProgressColor(
            totalPercentage,
          )}`}
          style={{ width: `${totalPercentage}%` }}
        >
          {totalPercentage}%
        </div>
      </MixtureListProgressStyled>
      {totalPercentage !== 100 && (
        <span style={{ color: "red", marginBottom: "12px" }}>
          {getValueForKey(translations, "edit_mix.step_0_warning_percentage")}
        </span>
      )}
    </>
  );
};
export default MixtureListProgress;
